import { DatePipe } from '@angular/common';
import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ContractListItem } from '@app/features/contracts/contract.model';
import { LucideTriangleAlert } from '@lucide/angular';

export type SignatureSendFailureFields = Partial<
  Pick<
    ContractListItem,
    'signatureSendFailedAt' | 'signatureSendFailedBy' | 'signatureSendFailureReason'
  >
>;

/**
 * Marque d'un contrat dont le dernier envoi en signature a échoué (RG-signature-echec-visible) :
 * quand, par qui, pourquoi. L'API l'efface au premier envoi réussi.
 */
@Component({
  selector: 'app-signature-send-failure',
  imports: [DatePipe, MatTooltipModule, LucideTriangleAlert],
  templateUrl: './signature-send-failure.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./signature-send-failure.scss'],
})
export class SignatureSendFailure {
  contract = input.required<SignatureSendFailureFields>();

  private readonly datePipe = new DatePipe('fr-FR');

  readonly failedAt = computed(() => this.contract().signatureSendFailedAt);

  readonly description = computed(() => {
    const { signatureSendFailedAt, signatureSendFailedBy, signatureSendFailureReason } =
      this.contract();
    if (!signatureSendFailedAt) {
      return '';
    }
    const date = this.datePipe.transform(signatureSendFailedAt, 'dd/MM/yyyy');
    const time = this.datePipe.transform(signatureSendFailedAt, 'HH:mm');
    const author = signatureSendFailedBy ? ` par ${signatureSendFailedBy}` : '';
    const reason = signatureSendFailureReason ? ` ${signatureSendFailureReason}` : '';
    return `Envoi en signature échoué le ${date} à ${time}${author}.${reason}`;
  });
}
